import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import HelpOutlineTwoToneIcon from '@mui/icons-material/HelpOutlineTwoTone';
import GavelTwoToneIcon from '@mui/icons-material/GavelTwoTone';
import AssignmentTwoToneIcon from '@mui/icons-material/AssignmentTwoTone';
import FolderOpenTwoToneIcon from '@mui/icons-material/FolderOpenTwoTone';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import ImageTwoToneIcon from '@mui/icons-material/ImageTwoTone';
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import PersonOutlineTwoToneIcon from '@mui/icons-material/PersonOutline';
import AdminPanelSettingsTwoToneIcon from '@mui/icons-material/AdminPanelSettingsTwoTone';


export const PageIcons = {
  Add: AddIcon,
  Edit: EditIcon,
  Delete: DeleteIcon,
  View: VisibilityIcon,
  Close: CloseIcon,
  Back: ArrowBackIcon,
  Search: SearchIcon,
  Save: SaveIcon,
  Refresh: RefreshIcon,
  Overview: DashboardTwoToneIcon,
  FAQ: HelpOutlineTwoToneIcon,
  Specializations: GavelTwoToneIcon,
  Consultations: AssignmentTwoToneIcon,
  Cases: FolderOpenTwoToneIcon,
  Lawyers: PeopleAltTwoToneIcon,
  Banners: ImageTwoToneIcon,
  Notifications: NotificationsActiveTwoToneIcon,
  Client: PersonOutlineTwoToneIcon,
  AdminStaff: AdminPanelSettingsTwoToneIcon
};
